@if (splashMounted()) {
  <app-splash-screen
    [active]="splashActive()"
    [quote]="splashQuote.text"
    [quoteAuthor]="splashQuote.author"
    (closed)="onSplashClosed()"
  />
}

@if (showMainChrome()) {
  <app-navbar
    (cartOpen)="openCartPanel()"
    (authOpen)="openAuthPage()"
    (notificationsOpen)="openNotificationsPanel()"
  ></app-navbar>
}
<div class="route-host" [@routeAnimations]="routeAnimationData()">
  <router-outlet></router-outlet>
</div>
@if (showMainChrome()) {
  <app-footer></app-footer>
}
@if (showMainChrome()) {
  <app-cart-panel [open]="cartOpen()" (closePanel)="closeCartPanel()" (authRequired)="openAuthPage()"></app-cart-panel>
  <app-notifications-panel [open]="notificationsOpen()" (closePanel)="closeNotificationsPanel()"></app-notifications-panel>
}
<app-toast></app-toast>
<app-purchase-success-modal></app-purchase-success-modal>
